module.exports = __webpack_public_path__ + "img/CMO.77337d53.jpg";